import { z } from "zod";
import { 
  ACTUAL_CLOSING_DATE,
  PROOF_TYPE,
  PROOF_FILE,
  CLOSING_PROOF_DOCS,
  STATUS,
  ATTACHMENT_ID,
  IS_REQUIRED,
  FILE_SIZE,
  FILE_TYPE,
  CLOSING_CONTACT_EMAIL,
  CC_EMAIL,
  DELIVERY_METHOD,
  EMAIL_SUBJECT,
  EMAIL_MESSAGE,
  CLOSING_ACK,
  UPLOADED_STATUS,
  PACKET_DOC_ID,
 } from "../../consts";

export const schema = z.object({
  [ACTUAL_CLOSING_DATE]: z.preprocess(
    (val) => (val === "" || val === null ? undefined : val),
    z.coerce.date({
      required_error: "This field is required",
      invalid_type_error: "Invalid Date"
    })
  ),
  [CLOSING_PROOF_DOCS]: z
    .array(
      z.object({
        [PACKET_DOC_ID]: z.string().optional(),
        [ATTACHMENT_ID]: z.string().optional(),
        [PROOF_TYPE]: z.string().optional(),
        [IS_REQUIRED]: z.boolean().optional(),
        [FILE_SIZE]: z.string().optional(),
        [FILE_TYPE]: z.string().optional(),
        [PROOF_FILE]: z.any().optional(),
        [UPLOADED_STATUS]: z.boolean().optional(),
      })
    ).optional(),
  [CLOSING_CONTACT_EMAIL]: z.string().optional(),
  [CC_EMAIL]: z.string().optional(),
  [DELIVERY_METHOD]: z.string().optional(),
  [EMAIL_SUBJECT]: z.string().optional(),
  [EMAIL_MESSAGE]: z.string().optional(),
  [CLOSING_ACK]: z.boolean().optional(),
  [STATUS]: z.string().optional(),
});


export type formValues = z.infer<typeof schema>;
